"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var immutability_helper_1 = require("immutability-helper");
var react_sortable_hoc_1 = require("react-sortable-hoc");
var classNames = require("classnames");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var photo_1 = require("./photo");
var editor_1 = require("./editor");
var thumb_list_1 = require("./thumb_list");
var uploader_1 = require("./uploader");
var humps_1 = require("humps");
var I18n = require("i18n-js");
var minimumDimension = 200; // (px) We will prevent images less than this on either isde.
var minimumWarnDimension = 620; // (px) We will warn them if less than this on either side.
var UncontrolledPhotos = /** @class */ (function (_super) {
    tslib_1.__extends(UncontrolledPhotos, _super);
    function UncontrolledPhotos(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            photos: (props.initialPhotos || []).map(function (photo) { return humps_1.camelizeKeys(photo); }),
        };
        _this.handlePhotosChange = _this.handlePhotosChange.bind(_this);
        return _this;
    }
    UncontrolledPhotos.prototype.handlePhotosChange = function (photos) {
        this.setState({ photos: photos });
    };
    UncontrolledPhotos.prototype.render = function () {
        return (React.createElement(ControlledPhotos, tslib_1.__assign({ onPhotosChange: this.handlePhotosChange, photos: this.state.photos }, this.props)));
    };
    return UncontrolledPhotos;
}(React.Component));
exports.UncontrolledPhotos = UncontrolledPhotos;
var ControlledPhotos = /** @class */ (function (_super) {
    tslib_1.__extends(ControlledPhotos, _super);
    function ControlledPhotos(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editingPhoto: null,
            isDroppingFile: false,
            warningTypeNames: [],
            showPrimaryPhotoWarning: false,
            showTooSmallWarning: false,
            showTooSmallError: false,
            showUploadFailureError: false,
        };
        _this.handleCloseEditor = _this.handleCloseEditor.bind(_this);
        _this.handleUpdatePhoto = _this.handleUpdatePhoto.bind(_this);
        _this.handlePhotoAdded = _this.handlePhotoAdded.bind(_this);
        _this.handleUploadFailure = _this.handleUploadFailure.bind(_this);
        _this.handleFileDropStart = _this.handleFileDropStart.bind(_this);
        _this.handleFileDropEnd = _this.handleFileDropEnd.bind(_this);
        _this.handleEditPhoto = _this.handleEditPhoto.bind(_this);
        _this.handleRemovePhoto = _this.handleRemovePhoto.bind(_this);
        _this.handleSortEnd = _this.handleSortEnd.bind(_this);
        _this.shouldCancelDrag = _this.shouldCancelDrag.bind(_this);
        return _this;
    }
    ControlledPhotos.prototype.newSmallPhoto = function (photo) {
        return this.props.requireMinimumDimensions && !photo.meetsMinimumDimension(minimumWarnDimension) && !photo.id;
    };
    Object.defineProperty(ControlledPhotos.prototype, "photos", {
        get: function () {
            var _this = this;
            return this.props.photos.map(function (photoAttrs) {
                var photo = new photo_1.default(photoAttrs);
                if (_this.newSmallPhoto(photo)) {
                    photo.showTooSmallWarning = true;
                }
                return photo;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlledPhotos.prototype, "isEditingPhoto", {
        get: function () {
            return !!this.state.editingPhoto;
        },
        enumerable: true,
        configurable: true
    });
    ControlledPhotos.prototype.handleEditPhoto = function (photo) {
        this.setState({ editingPhoto: photo });
    };
    ControlledPhotos.prototype.handleCloseEditor = function () {
        this.setState({ editingPhoto: null });
    };
    ControlledPhotos.prototype.handleUpdatePhoto = function (updatedPhoto) {
        this.updatePhoto(updatedPhoto);
        this.setState({ editingPhoto: null });
    };
    ControlledPhotos.prototype.handleRemovePhoto = function (photo) {
        this.removePhoto(photo);
        var anyRemainingPhotosTooSmall = this.photos.some(function (p) { return p.publicId !== photo.publicId && p.showTooSmallWarning; });
        if (!anyRemainingPhotosTooSmall) {
            this.closeErrorMessage('showTooSmallWarning');
        }
    };
    ControlledPhotos.prototype.removePhoto = function (photoToRemove) {
        var photoIndex = this.photos.findIndex(function (photo) {
            return photo.publicId === photoToRemove.publicId;
        });
        var newPhotos = immutability_helper_1.default(this.props.photos, {
            $splice: [[photoIndex, 1]],
        });
        this.updatePhotos(newPhotos);
    };
    ControlledPhotos.prototype.handlePhotoAdded = function (photo) {
        if (!this.props.requireMinimumDimensions || photo.meetsMinimumDimension(minimumWarnDimension)) {
            this.addPhoto(photo);
        }
        else if (photo.meetsMinimumDimension(minimumDimension)) {
            this.setState({ showTooSmallWarning: true });
            this.addPhoto(photo);
        }
        else {
            this.setState({ showTooSmallError: true });
        }
    };
    ControlledPhotos.prototype.handleUploadFailure = function () {
        this.setState({ showUploadFailureError: true });
    };
    ControlledPhotos.prototype.updatePhoto = function (updatedPhoto) {
        var photoIndex = this.photos.findIndex(function (photo) {
            return photo.publicId === updatedPhoto.publicId;
        });
        var photos = this.props.photos;
        photos[photoIndex] = updatedPhoto.attrsWithUpdates;
        this.updatePhotos(photos);
    };
    ControlledPhotos.prototype.updatePhotos = function (newPhotos) {
        this.props.onPhotosChange(newPhotos);
    };
    ControlledPhotos.prototype.addPhoto = function (photo) {
        var newPhotos = immutability_helper_1.default(this.props.photos, {
            $push: [photo.attrsWithUpdates],
        });
        this.updatePhotos(newPhotos);
    };
    ControlledPhotos.prototype.handleSortEnd = function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        this.updatePhotos(react_sortable_hoc_1.arrayMove(this.props.photos, oldIndex, newIndex));
    };
    ControlledPhotos.prototype.shouldCancelDrag = function (e) {
        if (e.target.tagName.toLowerCase() === 'a') {
            return true;
        }
        return false;
    };
    ControlledPhotos.prototype.handleFileDropStart = function () {
        this.setState({ isDroppingFile: true });
    };
    ControlledPhotos.prototype.handleFileDropEnd = function () {
        this.setState({ isDroppingFile: false });
    };
    ControlledPhotos.prototype.closeErrorMessages = function () {
        this.setState({
            showTooSmallWarning: false,
            showTooSmallError: false,
            showPrimaryPhotoWarning: false,
            showUploadFailureError: false,
        });
    };
    ControlledPhotos.prototype.closeErrorMessage = function (stateKey) {
        var newState = {};
        newState[stateKey] = false;
        this.setState(newState);
    };
    ControlledPhotos.prototype.tipText = function () {
        if (this.props.photos.length === 0) {
            return I18n.t('discovery.photos.tip.uploadOrDrop');
        }
        return I18n.t('discovery.photos.tip.reorder');
    };
    ControlledPhotos.prototype.renderEditor = function () {
        if (!this.isEditingPhoto) {
            return false;
        }
        return (React.createElement(editor_1.default, { photo: this.state.editingPhoto, onCloseEditor: this.handleCloseEditor, onUpdatePhoto: this.handleUpdatePhoto }));
    };
    ControlledPhotos.prototype.renderEditModal = function () {
        return (React.createElement(modal_1.default, { isOpen: this.isEditingPhoto }, this.renderEditor()));
    };
    ControlledPhotos.prototype.renderUploader = function () {
        return (React.createElement(uploader_1.default, { uploadOptions: this.props.uploadOptions, onFileAdded: this.handlePhotoAdded, onDragStart: this.handleFileDropStart, onDragEnd: this.handleFileDropEnd, onUploadFailure: this.handleUploadFailure, dropZoneSelector: this.props.dropZoneSelector }));
    };
    ControlledPhotos.prototype.renderError = function (stateKey, heading, message, cssModifier, warningName) {
        var _this = this;
        if (warningName === void 0) { warningName = null; }
        var className = classNames('img-uploader__message', "img-uploader__message--" + cssModifier);
        return (React.createElement("div", { className: className, key: warningName },
            React.createElement("a", { className: "img-uploader__message__close", onClick: function () { return _this.closeErrorMessage(stateKey); } }),
            React.createElement("strong", null, heading),
            React.createElement("div", { className: "small pt-half" }, message)));
    };
    ControlledPhotos.prototype.renderUploadFailureError = function () {
        if (this.state.showUploadFailureError) {
            return this.renderError('showUploadFailureError', I18n.t('discovery.photos.uploadFailureHeading'), I18n.t('discovery.photos.uploadFailure'), 'error');
        }
        return null;
    };
    ControlledPhotos.prototype.renderTooSmallWarning = function () {
        if (this.state.showTooSmallWarning) {
            return this.renderError('showTooSmallWarning', I18n.t('discovery.photos.smallImageWarningHeading'), I18n.t('discovery.photos.smallImageWarning'), 'warn');
        }
        return null;
    };
    ControlledPhotos.prototype.renderTooSmallError = function () {
        if (this.state.showTooSmallError) {
            return this.renderError('showTooSmallError', I18n.t('discovery.photos.smallImageErrorHeading'), I18n.t('discovery.photos.smallImageError'), 'error');
        }
        return null;
    };
    ControlledPhotos.prototype.renderPrimaryPhotoWarning = function () {
        var _this = this;
        if (this.state.showPrimaryPhotoWarning) {
            return this.state.warningTypeNames.map(function (warningName) {
                return _this.renderError('showPrimaryPhotoWarning', I18n.t("discovery.photos." + warningName + "WarningHeading"), I18n.t("discovery.photos." + warningName + "Warning"), 'warn', warningName);
            });
        }
        return null;
    };
    ControlledPhotos.prototype.renderThumbs = function () {
        return (React.createElement(thumb_list_1.default, { photos: this.photos, onEditPhoto: this.handleEditPhoto, onRemovePhoto: this.handleRemovePhoto, axis: "xy", onSortEnd: this.handleSortEnd, shouldCancelStart: this.shouldCancelDrag, allowEdit: this.props.allowEdit }, this.renderUploader()));
    };
    ControlledPhotos.prototype.renderDropFileOverlay = function () {
        if (this.state.isDroppingFile) {
            return (React.createElement("div", { className: "img-uploader__drop-file-overlay" }, I18n.t('discovery.photos.drop_files')));
        }
        return null;
    };
    ControlledPhotos.prototype.renderPhotosField = function () {
        var value = JSON.stringify(this.photos.map(function (photo) { return humps_1.decamelizeKeys(photo.attrsWithUpdates); }));
        return (React.createElement("input", { type: "hidden", name: this.props.inputName + "[]", value: value, className: "img-uploader__photos-input" }));
    };
    ControlledPhotos.prototype.renderPhotoOrderFields = function () {
        return this.photos.map(function (photo, index) {
            var inputName = "photo_order[" + photo.publicId + "]";
            return (React.createElement("input", { type: "hidden", name: inputName, value: index, key: photo.publicId, className: "img-uploader__photo-order-input" }));
        });
    };
    ControlledPhotos.prototype.renderImageDetectionFeedbackField = function () {
        if (!this.state.warnedPrimaryImageId) {
            return null;
        }
        var inputName = 'photo_detection_feedback';
        return (React.createElement("input", { type: "hidden", name: inputName, value: this.state.warnedPrimaryImageId }));
    };
    ControlledPhotos.prototype.renderTip = function () {
        if (!this.props.renderTip) {
            return null;
        }
        return (React.createElement("div", { className: "img-uploader__tip" }, this.tipText()));
    };
    ControlledPhotos.prototype.render = function () {
        return (React.createElement("div", { ref: "container", className: "img-uploader" },
            this.renderTip(),
            this.renderUploadFailureError(),
            this.renderTooSmallError(),
            this.renderTooSmallWarning(),
            this.renderPrimaryPhotoWarning(),
            this.renderThumbs(),
            this.renderEditModal(),
            this.renderDropFileOverlay(),
            this.renderPhotosField(),
            this.renderPhotoOrderFields(),
            this.renderImageDetectionFeedbackField()));
    };
    ControlledPhotos.defaultProps = {
        photos: [],
        requireMinimumDimensions: true,
        allowEdit: true,
        renderTip: true,
        shouldDetectImages: false,
    };
    return ControlledPhotos;
}(React.Component));
exports.ControlledPhotos = ControlledPhotos;
//# sourceMappingURL=photos.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/photos.js
// module id = 3eG/
// module chunks = 20 21